/**
 * App Store URLs for the Home CEO mobile app.
 *
 * Consumed by the landing page's download CTAs (nav, hero, Download-Now
 * section, footer). Kept as constants so every store button on every
 * surface points at the same URL and swapping the ID in one place is
 * enough.
 */

export const APP_STORE_URL = 'https://apps.apple.com/app/id6761034435';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=ai.homeceo.app';
